/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  // Seal Subscrption Default Selection
/**
 * Force Seal Subscriptions to default to 'Subscribe & Save'
 */
const selectSealSubscription = () => {
  // 1. Find the subscription radio button using its unique data attribute
  const subRadio = document.querySelector('.sls-purchase-options-container input[data-type="subscription"]');
  const oneTimeContainer = document.querySelector('.sls-option-container[data-prepaid="false"]'); // The one-time div
  
  if (subRadio) {
    // 2. Simulate a click on the radio button
    // This triggers Seal's internal scripts to update prices and hidden inputs
    subRadio.click();

    // 3. Optional: Ensure the 'active' class is swapped if the click doesn't do it instantly
    const subContainer = subRadio.closest('.sls-option-container');
    if (subContainer && !subContainer.classList.contains('sls-active')) {
      document.querySelectorAll('.sls-option-container').forEach(el => el.classList.remove('sls-active'));
      subContainer.classList.add('sls-active');
    }
    
    return true; // Success
  }
  return false; // Not found yet
};

// 4. Run a check every 200ms until the widget is found (up to 5 seconds)
let checkCount = 0;
const sealInterval = setInterval(() => {
  const success = selectSealSubscription();
  checkCount++;

  if (success || checkCount > 100) {
    clearInterval(sealInterval);
  }
}, 200);


// Show only on Brand
document.addEventListener('DOMContentLoaded', function() {
  function updateBrandDisplay(value) {
    const brand = value.toLowerCase().replace(/\s+/g, '-');
    // Hide all
    document.querySelectorAll('[class*="show-brand--"]').forEach(el => {
      el.classList.remove('show-brand--visible');
    });
    // Show matching
    const target = document.querySelectorAll(`.show-brand--${brand}`);
    target.forEach(el => {
      el.classList.add('show-brand--visible');
    });
  }

  document.querySelectorAll('input[name^="options[Flavour]"]').forEach(radio => {
    // On change
    radio.addEventListener('change', function() {
      if (this.checked) {
        updateBrandDisplay(this.value);
      }
    });
    // On page load (default selected)
    if (radio.checked) {
      updateBrandDisplay(radio.value);
    }
  });
});


  // Star Rating Scroll Anchor
  document.addEventListener("DOMContentLoaded", function () {
  const ratings = document.querySelectorAll(".jdgm-rating");
  const carousel = document.querySelector(".jdgm-cards-carousel");

  if (!carousel) return;

  ratings.forEach(function(rating) {
    rating.addEventListener("click", function(e) {
      e.preventDefault();

      const offset = 120; // adjust for header height
      const elementPosition = carousel.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth"
      });
    });
  });
});

/* Video */
document.querySelectorAll('.socialproof-media').forEach(slide => {
  slide.addEventListener('click', () => {
    const card = slide.closest('.socialproof-card');
    const video = slide.querySelector('video');

    if (!video) return;

    const isMuted = video.muted;

    // Reset all videos + states
    document.querySelectorAll('.socialproof-card').forEach(c => {
      c.classList.remove('is-playing');
    });

    document.querySelectorAll('.socialproof-media video').forEach(v => {
      v.muted = true;
    });

    // Toggle current
    if (isMuted) {
      video.muted = false;
      video.play();
      card.classList.add('is-playing');
    } else {
      video.muted = true;
      card.classList.remove('is-playing');
    }
  });
});


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
